import { render, staticRenderFns } from "./SelectorCategory.vue?vue&type=template&id=075b6d6c&"
import script from "./SelectorCategory.vue?vue&type=script&lang=js&"
export * from "./SelectorCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports